import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

export interface QuestRequirementDto {
	id: string;
	questId: string;
	questName: string | null;
	name: string;
	description: string | null;
	status: string | null;
	imageAssetId: string | null;
	foundryId: string | null;
	createdAt: string;
	updatedAt: string;
}

export interface QuestRequirementsListResponse {
	questRequirements: QuestRequirementDto[];
	total: number;
}

export interface QuestRequirementGetResponse {
	questRequirement: QuestRequirementDto;
}

export interface UpsertQuestRequirementRequest {
	questId: string;
	name: string;
	description?: string | null;
	status?: string | null;
	imageAssetId?: string | null;
	foundryId?: string | null;
}

@Injectable({ providedIn: 'root' })
export class QuestRequirementsService {
	constructor(private readonly http: HttpClient) {}

	list(
		worldId: string,
		args?: { q?: string; questId?: string; poiId?: string }
	): Observable<QuestRequirementsListResponse> {
		let params = new HttpParams().set('format', 'list');
		if (args?.q) params = params.set('q', args.q);
		if (args?.questId) params = params.set('questId', args.questId);
		if (args?.poiId) params = params.set('poiId', args.poiId);
		return this.http.get<QuestRequirementsListResponse>(
			`${environment.api.baseUrl}/v1/worlds/${worldId}/quest-requirements`,
			{ params }
		);
	}

	get(worldId: string, requirementId: string): Observable<QuestRequirementGetResponse> {
		return this.http.get<QuestRequirementGetResponse>(
			`${environment.api.baseUrl}/v1/worlds/${worldId}/quest-requirements/${requirementId}`
		);
	}

	create(worldId: string, request: UpsertQuestRequirementRequest): Observable<QuestRequirementGetResponse> {
		return this.http.post<QuestRequirementGetResponse>(
			`${environment.api.baseUrl}/v1/worlds/${worldId}/quest-requirements`,
			{
				QuestId: request.questId,
				Name: request.name,
				Description: request.description ?? null,
				Status: request.status ?? null,
				ImageAssetId: request.imageAssetId ?? null,
				FoundryId: request.foundryId ?? null,
			}
		);
	}

	update(
		worldId: string,
		requirementId: string,
		request: UpsertQuestRequirementRequest
	): Observable<QuestRequirementGetResponse> {
		return this.http.put<QuestRequirementGetResponse>(
			`${environment.api.baseUrl}/v1/worlds/${worldId}/quest-requirements/${requirementId}`,
			{
				QuestId: request.questId,
				Name: request.name,
				Description: request.description ?? null,
				Status: request.status ?? null,
				ImageAssetId: request.imageAssetId ?? null,
				FoundryId: request.foundryId ?? null,
			}
		);
	}

	delete(worldId: string, requirementId: string): Observable<void> {
		return this.http.delete<void>(
			`${environment.api.baseUrl}/v1/worlds/${worldId}/quest-requirements/${requirementId}`
		);
	}
}
